import { useContext } from 'react';
import { PermitionContext } from '@/contexts/Permition';

export const usePermition = () => useContext(PermitionContext);